import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import * as Actions from '../../../actions/actions';

/* eslint no-unused-vars: 0 */
import GetQuotesButton from './GetQuotesButton';
import { FormEditableInput } from '../../elements/EditableInput';
import FormDropdown from '../../elements/Dropdown';
import FormMultiSelect from '../../elements/MultiSelect';
import Selector from '../../elements/Selector';

import * as EventHandler from '../../../services/EventHandler';

import FeatureToggleService from '../../../services/FeatureToggleService';

const MORTGAGE_ADVICE_ID = 392;
const MORTGAGE_PAGE_LINK = 'http://offers.vouchedfor.co.uk/mortgage-adviser/get-free-quote/' +
    '?utm_source=discover&utm_medium=button&utm_campaign=redirect';

export class Form extends Component {
    componentWillMount() {
        this.setState({ phone: '' });

        const experiment = JSON.parse(FeatureToggleService.instance.getFeatureValue('addMoreServices'));
        EventHandler.track('Viewed Form', {
            category: 'Landing Page',
            label: experiment.name,
        });

        this.addMoreServices = experiment.value;
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ phone: nextProps.person.get('phone') });
    }

    handleChange(event) {
        this.props.actions.updatePersonAttribute(event.target.name, event.target.value);
        this.forceUpdate();
    }

    // This is necessary due to chrome auto-fill not triggering javascript events
    updateAllFieldsBasedOnRefs() {
        this.props.actions.updatePersonAttribute('wealthLevel', this.refs.wealthLevel.getValue());
    }

    submitQuoteRequest() {
        if (!this.props.canSubmit) {
            return;
        }

        if (this.props.person.get('adviceArea') && this.props.person.get('adviceArea').split(',').length > 1) {
            const adviceAreas = this.props.person.get('adviceArea').split(',');
            this.props.actions.updatePersonAttribute('adviceArea', adviceAreas[0]);
            this.props.actions.updatePersonAttribute('otherAdviceAreas', adviceAreas.slice(1));
        }

        /* eslint eqeqeq: 0 */
        if (this.props.person.get('adviceArea') == MORTGAGE_ADVICE_ID) {
            window.location.href = MORTGAGE_PAGE_LINK;
            return;
        }

        this.updateAllFieldsBasedOnRefs();

        browserHistory.push('contact');
    }

    renderRequiredNotification() {
        if (!this.props.invalidSubmit) {
            return null;
        }

        const requiredMessage = 'Please fill the required fields';
        return <div className="app__form__page-error">{ requiredMessage }</div>;
    }

    renderDropdownOrMultiSelect(maxWidthInputs) {
        if (this.addMoreServices) {
            const options = [
                { value: '391', label: 'Insurance & Protection' },
                { value: '396', label: 'Auto Enrolment' },
                { value: '397', label: 'Investments & Savings' },
                { value: '392', label: 'Mortgages' },
                { value: '393', label: 'Pension & Retirement' },
                { value: '557', label: 'Pension Transfers - Non Specialist' },
                { value: '394', label: 'Equity Release' },
                { value: '558', label: 'Inheritance Planning' },
                { value: '395', label: 'Annuities' },
            ];

            return (
                <FormMultiSelect name="adviceArea"
                                 ref="adviceArea"
                                 sublabel="You can select more than one service"
                                 value={ this.props.person.get('adviceArea') }
                                 options={ options }
                                 widthProportion="fixed"
                                 invalidSubmit={ this.props.invalidSubmit }
                                 handleChange={ this.handleChange.bind(this) }
                                 fixedWidth={ maxWidthInputs }
                                 required />
            );
        }


        return (
            <FormDropdown name="adviceArea"
                          ref="adviceArea"
                          value={ this.props.person.get('adviceArea') }
                          optionsType="adviceArea"
                          blankOptionLabel="primary advice area"
                          blankOption={ true }
                          widthProportion="fixed"
                          invalidSubmit={ this.props.invalidSubmit }
                          handleChange={ this.handleChange.bind(this) }
                          fixedWidth={ maxWidthInputs }
                          required/>
        );
    }

    render() {
        const maxWidthInputs = this.addMoreServices ? '305px' : '280px';
        const adviceAreaTitle = this.addMoreServices ? 'What are you seeking advice on?' :
           'What are you looking for advice on?';

        return (
            <div>
                <div className="app__form__grid__column">
                    <div className="hero-banner__form-label__container">
                        <div className="hero-banner__form-label">
                            { adviceAreaTitle }
                        </div>
                    </div>
                    { this.renderDropdownOrMultiSelect(maxWidthInputs)}
                </div>

                <div className="app__form__grid__column">
                    <div className="hero-banner__form-label__container">
                        <div className="hero-banner__form-label">
                            How much are your savings/investments/pensions worth?
                        </div>
                    </div>
                    <FormEditableInput name="wealthLevel"
                                       ref="wealthLevel"
                                       placeholder="£50,000"
                                       value={ this.props.person.get('wealthLevel') }
                                       maxLength={ 11 }
                                       invalidSubmit={ this.props.invalidSubmit }
                                       widthProportion="fixed"
                                       fixedWidth={ maxWidthInputs }
                                       maskType="currency"
                                       handleChange={ this.handleChange.bind(this) }
                                       required/>
                </div>

                <div className="app__form__grid__column">
                    <div className="app__form__actions">
                        <GetQuotesButton section="Hero Banner"
                                         wording="Get Free IFA Quotes"
                                         size="big"
                                         handler={ this.submitQuoteRequest.bind(this) } />
                    </div>
                </div>

                { this.renderRequiredNotification() }

            </div>
        );
    }
}

Form.propTypes = {
    canSubmit: React.PropTypes.bool,
    invalidSubmit: React.PropTypes.bool,

    actions: React.PropTypes.object,
    person: React.PropTypes.object,
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

function mapStateToProps(state) {
    return {
        canSubmit: state.navigation.get('canSubmit'),
        invalidSubmit: state.navigation.get('invalidSubmit'),

        person: state.reducer.get('person'),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Form);



// WEBPACK FOOTER //
// ./src/components/steps/landing/Form.jsx